<a-button :loading="loading" type="primary" @click="showModal">源单导入</a-button>

<a-modal
  v-model:visible="visible"
  width="1000px"
  :keyboard="false"
  :centered="true"
  :mask-closable="false"
  @ok="ok"
  @cancel="closeModal"
>
  <template #title>
    <span>选择工程量清单</span>
    <small class="text-grey ml10">选中仅对当前页有效</small>
  </template>
  <a-form layout="inline">
    <a-form-item>
      <a-input-search
        v-model:value.trim="queryRef.name"
        placeholder="请输入清单名称关键字"
        style="width: 250px"
        enter-button
        allow-clear
        :loading="loading"
        @search="search"
      ></a-input-search>
    </a-form-item>
  </a-form>

  <!-- <a-table
    size="small"
    row-key="id"
    class="mt15"
    :bordered="true"
    :loading="loading"
    :data-source="dataSource?.records"
    :columns="columns"
    :scroll="{ x: 1100 }"
    :pagination="false"
    :row-selection="{
      selectedRowKeys: selectedIds,
      onChange: onSelectionChange,
      fixed: true,
    }"
  > -->
  <table-wrapper
    :dataSource="dataSource?.records"
    @onSelectionChange="onSelectionChange"
    :tableHeight="400"
    :loading="loading"
    :columns="columns"
  >
    <!-- <template #index="{ record, index }">{{ index + 1 }}</template> -->
    <template #price="{ record }">{{ $filters.formatMoney(record.price) }}</template>
    <template #totalPrice="{ record }">{{ $filters.formatMoney(record.totalPrice) }}</template>
  </table-wrapper>
</a-modal>
